import { List, ListItem, ListItemIcon, ListItemText, Typography, Button, Box, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { InfoCard, Link } from '@backstage/core-components';
import EmailIcon from '@material-ui/icons/Email';
import DescriptionIcon from '@material-ui/icons/Description';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(theme => ({
  list: {
    padding: 0,
  },
  listItem: {
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  iconContainer: {
    minWidth: 36,
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 20,
  },
  date: {
    fontSize: '0.7rem',
  },
  viewAllButton: {
    textTransform: 'none',
  },
  sectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
}));

interface Newsletter {
  title: string;
  date: string;
  href: string;
}

const newsletters: Newsletter[] = [
  {
    title: 'January 2026 Newsletter',
    date: 'Jan 2026',
    href: '/docs/default/component/avid-developer-portal/ai-central/newsletters/2026-01/',
  },
];

export const NewsletterSection = () => {
  const classes = useStyles();

  return (
    <InfoCard
      title="Newsletter"
      action={
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          className={classes.viewAllButton}
          href="/docs/default/component/avid-developer-portal/ai-central/newsletters/"
        >
          Archive
        </Button>
      }
    >
      <Box>
        <Typography className={classes.sectionTitle}>
          Latest Issues
        </Typography>
        <List className={classes.list}>
          {newsletters.map(newsletter => (
            <ListItem
              key={newsletter.title}
              className={classes.listItem}
              button
              component={Link}
              to={newsletter.href}
            >
              <ListItemIcon className={classes.iconContainer}>
                <DescriptionIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText
                primary={newsletter.title}
                secondary={newsletter.date}
                classes={{ secondary: classes.date }}
              />
            </ListItem>
          ))}
        </List>
        <Divider className={classes.divider} />
        <Typography className={classes.sectionTitle}>
          Stay Updated
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Get the latest AI news, tips, and updates delivered to your inbox monthly.
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EmailIcon />}
          size="small"
          fullWidth
          href="mailto:ai-central@avidxchange.com?subject=Subscribe to AI Central Newsletter"
        >
          Subscribe
        </Button>
      </Box>
    </InfoCard>
  );
};
